export default "__VITE_ASSET__BWCl$uGb__"